<template>
  <div class="totalRecord">
    <div class="ele-table-tool ele-table-tool-default">
      <span>开始时间：</span>
      <el-date-picker v-model="startDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 150px" />
      <span>结束时间：</span>
      <el-date-picker v-model="endDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 150px" />
      <el-button @click="getTotalData" type="primary" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
      <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
    </div>
    <!-- 数据表格 -->
    <ele-data-table size="mini" ref="table" :config="table" :data="data" :choose.sync="choose" highlight-current-row height="calc(100vh - 330px)">
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column v-for="(item, index) in examineAttendanceNameList" :key="index" :label="item">
          <template #default="{ row }">
            <span v-if="row[item].indexOf('-') == -1">{{ row[item] }}</span>
            <span v-else style="color: red">{{ row[item] }}</span>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
  </div>
</template>

<script>
  import { getClassGeneralItemStatisticsByDate, exportClassGeneralItemStatisticsByDate } from '@/config/api';

  export default {
    name: 'TotalRecord',
    data() {
      return {
        gradeId: '',
        table: {
          // 表格配置
          page: false,
        },
        startDate: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
        endDate: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
        choose: [], // 表格选中数据
        data: [],
        examineAttendanceNameList: [],
      };
    },
    methods: {
      // 获取统计
      getTotalData() {
        let data = {
          startDate: this.startDate,
          endDate: this.endDate,
          gradeId: this.gradeId,
        };
        getClassGeneralItemStatisticsByDate(data).then((res) => {
          if (res.data.resCode == 200) {
            this.data = res.data.data.records;
            this.examineAttendanceNameList = res.data.data.examineAttendanceNameList;
          }
        });
      },
      exportData() {
        let data = {
          startDate: this.startDate,
          endDate: this.endDate,
          gradeId: this.gradeId,
        };
        exportClassGeneralItemStatisticsByDate(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped>
  .totalRecord {
    margin-top: 10px;
  }
</style>
